import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Descargas el eBook inmediatamente.',
    description: 'Acceso instantáneo a todo el material, plantillas y checklists en cuanto completas tu pedido.'
  }, {
    number: '02',
    title: 'Sigues el plan de 48 horas, paso a paso.',
    description: 'Instrucciones claras y sin jerga técnica para que sepas exactamente qué hacer cada día.'
  }, {
    number: '03',
    title: 'Configuras tu primera automatización y la pones en marcha.',
    description: 'Observa cómo la IA empieza a trabajar por ti, liberando horas de tu semana.'
  }];
  return <section className="py-24 bg-[#141414] border-y border-white/5" data-id="element-142">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="text-center mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-145">
            Cómo Funciona
          </h2>
          <p className="text-xl text-gray-400" data-id="element-146">
            Tu camino hacia la automatización en 3 simples pasos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-147">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gradient-to-r from-transparent via-amber-500/30 to-transparent" data-id="element-148" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative pt-8 md:pt-0" data-id="element-149">
              <div className="bg-[#0A0A0A] w-24 h-24 rounded-full flex items-center justify-center border-4 border-[#141414] shadow-[0_0_30px_rgba(245,158,11,0.15)] mx-auto mb-8 relative z-10" data-id="element-150">
                <span className="text-3xl font-bold text-amber-500" data-id="element-151">
                  {step.number}
                </span>
              </div>
              <div className="text-center" data-id="element-152">
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-153">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-154">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}